import React from 'react'
import { PickingSquareColors } from '../../const/pickingReportConst'
import { PickingItemProps } from './interfaces'
import { useStyles } from './styles'
import { PickingReportBusiness } from '../../actions/PickingReportBusiness'

export const PickingItem = ({ height, qty, title, id }: PickingItemProps) => {
  const classes = useStyles()
  const { getSearchDetail } = PickingReportBusiness()
  return (
    <div
      onClick={() => getSearchDetail({ id, qty, title, height: '40%' })}
      className={classes.item}
      style={{
        height,
        backgroundColor: PickingSquareColors.find(
          (element) => element.id === id
        )?.color
      }}
    >
      <strong>{`${qty} - ${title}`}</strong>
    </div>
  )
}
